module.exports = "/_next/static/images/devfolio-b4834dd075a1add3da5acfebedebd437.png";